import { render, staticRenderFns } from "./IcoachSkillForm.vue?vue&type=template&id=c43c4f80&"
import script from "./IcoachSkillForm.vue?vue&type=script&lang=ts&"
export * from "./IcoachSkillForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports